import { Box, SxProps, useTheme } from '@mui/material';
import EditorArea from './EditorArea';
import { TokenType } from '../../../features/common2/Templating/WysiwygEditor';
import useEditor from './hooks/content-editor-hooks';
import ContentEditorToolbar from './ContentEditorToolbar/ContentEditorToolbar';

type Props = {
    sx?: SxProps;
    html: string;
    onChange: (updatedHtml: string) => void;
    tokenType: TokenType;
    showToolbar?: boolean;
    textMode?: boolean;
    disabled?: boolean;
    error?: boolean;
};

const ContentEditor = ({
    sx,
    html,
    onChange,
    tokenType,
    showToolbar = true,
    textMode = false,
    disabled = false,
    error = false,
}: Props) => {
    const theme = useTheme();
    const { ref, tokens, handleCommand, onPaste } = useEditor(tokenType);

    const handleUpdate = () => {
        if (!ref.current) return;
        onChange(ref.current.innerHTML);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 auto',
                overflowY: 'auto',
                boxSizing: 'border-box',
                border: `1px solid ${!error ? theme.palette.divider : theme.palette.error.main}`,
                ...sx,
            }}
        >
            {showToolbar && <ContentEditorToolbar onCommand={handleCommand} tokens={tokens} />}
            <EditorArea ref={ref} html={html} onUpdate={handleUpdate} onPaste={onPaste} disabled={disabled} />
        </Box>
    );
};

export default ContentEditor;
